var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"bg-cover bg-center",class:_vm.repeat ? 'bg-repeat' : 'bg-no-repeat',style:(`background-image: url(${_vm.url});${_vm.aspectRatioPadding}}`)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }